/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_len_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exactly 2.54 centimeters — this has been the internationally agreed definition since 1959, so it's not a rounded approximation. That makes it the most reliable anchor point for converting between metric and imperial length units; every other inch-based conversion (feet, yards, miles) derives from this fixed ratio.`)
};

const es_uc_len_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exactamente 2.54 centímetros — esta ha sido la definición acordada internacionalmente desde 1959, así que no es una aproximación redondeada. Eso la convierte en el punto de anclaje más confiable para convertir entre unidades de longitud métrica e imperial; cada otra conversión basada en pulgadas (pies, yardas, millas) se deriva de esta razón fija.`)
};

const de_uc_len_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exakt 2.54 Zentimeter — das ist seit 1959 die international vereinbarte Definition, also keine gerundete Näherung. Das macht sie zum verlässlichsten Ankerpunkt für die Umrechnung zwischen metrischen und imperialen Längeneinheiten; jede weitere zoll-basierte Umrechnung (Fuß, Yards, Meilen) leitet sich aus diesem festen Verhältnis ab.`)
};

const nl_uc_len_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exact 2,54 centimeter — dit is sinds 1959 de internationaal overeengekomen definitie, dus het is geen afgeronde benadering. Dit maakt het het meest betrouwbare ankerpunt voor het converteren tussen metrische en imperiale lengte-eenheden; elke ander op inches gebaseerde conversie (voeten, yards, mijlen) is afgeleid van deze vaste verhouding.`)
};

const fr_uc_len_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exactement 2,54 centimètres — c'est la définition convenue internationalement depuis 1959, donc ce n'est pas une approximation arrondie. C'est le point d'ancrage le plus fiable pour convertir entre les unités de longueur métriques et impériales ; chaque autre conversion basée sur le pouce (pieds, verges, miles) découle de ce rapport fixe.`)
};

const it_uc_len_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esattamente 2,54 centimetri — questa è la definizione internazionalmente concordata dal 1959, quindi non è un'approssimazione arrotondata. Ciò la rende il punto di ancoraggio più affidabile per convertire tra le unità di lunghezza metriche e imperiali; ogni altra conversione basata su pollici (piedi, iarde, miglia) deriva da questo rapporto fisso.`)
};

const pt_br2_uc_len_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exatamente 2.54 centímetros — esta tem sido a definição acordada internacionalmente desde 1959, então não é uma aproximação arredondada. Isto a torna o ponto de âncora mais confiável para converter entre unidades de comprimento métricos e imperiais; cada outra conversão baseada em polegadas (pés, jardas, milhas) é derivada desta proporção fixa.`)
};

const pt_uc_len_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exactamente 2,54 centímetros — esta tem sido a definição internacionalmente acordada desde 1959, portanto não é uma aproximação arredondada. Isto torna-a o ponto de ancoragem mais fiável para converter entre unidades de comprimento métricas e imperiais; todas as outras conversões baseadas em polegadas (pés, jardas, milhas) derivam desta razão fixa.`)
};

const ja_uc_len_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正確に2.54センチメートル — これは1959年以来国際的に合意された定義であるため、丸めた近似ではありません。メートル法とヤード・ポンド法の長さ単位間で変換するための最も信頼できるアンカーポイントになります。他のすべてのインチベースの変換(フィート、ヤード、マイル)はこの固定比率から導出されています。`)
};

const zh_uc_len_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_len_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_len_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_len_faq1_a", locale)
	if (locale === "en") return en_uc_len_faq1_a(inputs)
	if (locale === "es") return es_uc_len_faq1_a(inputs)
	if (locale === "de") return de_uc_len_faq1_a(inputs)
	if (locale === "nl") return nl_uc_len_faq1_a(inputs)
	if (locale === "fr") return fr_uc_len_faq1_a(inputs)
	if (locale === "it") return it_uc_len_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_len_faq1_a(inputs)
	if (locale === "pt") return pt_uc_len_faq1_a(inputs)
	if (locale === "ja") return ja_uc_len_faq1_a(inputs)
	return zh_uc_len_faq1_a(inputs)
};